import { useTranslation } from 'react-i18next';

import { Icons } from '@/shared/ui';

import styles from './ViewOptions.module.css';

/** A small icon button next to the display switches: "create an event from a sentence". */
export function TextCreateButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={styles.button}
      aria-label={t('calendar.text.open')}
      title={t('calendar.text.open')}
      aria-haspopup="dialog"
      data-testid="text-create"
      onClick={onClick}
    >
      <Icons.fieldText />
    </button>
  );
}
